import clearRefiners from '../actions/clearRefiners';
import setFromDate from '../actions/setFromDate';
import setIncludeAttachments from '../actions/setIncludeAttachments';
import setToDate from '../actions/setToDate';
import { defaultMailSearchStore, getStore } from '../store/store';
import { mutator } from 'satcheljs';

mutator(clearRefiners, () => {
    const mailSearchStore = getStore();

    // Reset refiners.
    mailSearchStore.fromDate = defaultMailSearchStore.fromDate;
    mailSearchStore.toDate = defaultMailSearchStore.toDate;
    mailSearchStore.includeAttachments = defaultMailSearchStore.includeAttachments;

    /**
     * staticSearchScope is reset to initialSearchScope when search session
     * started instead of using default value (because default value is null).
     */
    mailSearchStore.staticSearchScope = getStore().initialSearchScope;
});

mutator(setFromDate, actionMessage => {
    getStore().fromDate = actionMessage.fromDate;
});

mutator(setToDate, actionMessage => {
    getStore().toDate = actionMessage.toDate;
});

mutator(setIncludeAttachments, actionMessage => {
    getStore().includeAttachments = actionMessage.includeAttachments;
});
